import { Component, OnInit, computed, effect, inject, signal } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SettingService } from '../../../services/setting.service';

@Component({
  selector: 'app-setting',
  standalone: false,
  templateUrl: './setting.component.html',
  styleUrl: './setting.component.scss',
})
export class SettingComponent implements OnInit {
  private settingService = inject(SettingService);
  private sheetRef = inject(MatBottomSheetRef<SettingComponent>);

  hasMultiLanguage = computed(() => this.settingService.hasMultiLanguage());
  hasMultiCurrency = computed(() => this.settingService.hasMultiCurrency());
  languages = computed(() => this.settingService.languages());
  currencies = computed(() => this.settingService.currencies());

  selectedLanguage = signal<string>('');
  selectedCurrency = signal<string>('');

  constructor() {
    effect(() => {
      this.selectedLanguage.set(this.settingService.currentLanguage());
    });
    effect(() => {
      this.selectedCurrency.set(this.settingService.currentCurrency());
    });
  }

  ngOnInit(): void {
    this.settingService.setCurrencies();
  }

  selectLanguage(lang: string): void {
    this.selectedLanguage.set(lang);
  }

  selectCurrency(currency: string): void {
    this.selectedCurrency.set(currency);
  }

  confirm(): void {
    this.settingService.applyLanguage(this.selectedLanguage());
    this.settingService.applyCurrency(this.selectedCurrency());
    this.close();
  }

  close(): void {
    this.sheetRef.dismiss();
  }
}
